import React from 'react';
import { View } from 'react-native';

export const WinBackgroundGradient = () => {
    return <View />;
};
